angular
.module("tablePaginationArf.components", [])
.component("tablePaginationArf", {
  controllerAs: 'TransactionTableArfCtrl',
  templateUrl: "ng/components/tablePaginationArf/tablePaginationArf.html",
  bindings: {
    goToNext: "@",
    goToPrevious: "@",
    pageIndex: "=",
    totalPages: "<",
    parentComponent: "@"
  },
  controllerAs: "tablePaginationArfCtrl",
  controller: function ($scope, $rootScope) {
    //Not to loose the *this reference
    var self = this;
    /**
     * Init bindings here
     */
    self.$onInit = function () {
      /** Extract the map of the current language **/
      var currentLanguage = $rootScope.selectedLanguage;
      self.lang = langItems
        .filter(function (map) {
          return map.code == currentLanguage;
        })
        .map(function (value) {
          return value.map;
        })[0];
    };

    self.backward = function () {
      self.parentComponent
        ? $scope.$parent[self.parentComponent][self.goToPrevious]()
        : $scope.$parent[self.goToPrevious]();
    },

      self.doubleBackward = function () {
        self.parentComponent
          ? $scope.$parent[self.parentComponent][self.goToPrevious]("init")
          : $scope.$parent[self.goToPrevious]("init");
      },

      self.forward = function () {
        self.parentComponent
          ? $scope.$parent[self.parentComponent][self.goToNext]()
          : $scope.$parent[self.goToNext]();
      },

      self.doubleForward = function () {
        self.parentComponent 
          ? $scope.$parent[self.parentComponent][self.goToNext]('end') 
          : $scope.$parent[self.goToNext]('end');
      };

  }
});
